<script setup>
import { useStore } from 'vuex';
import ClusteredJobsMap from 'JIX/components/map/ClusteredJobsMap.vue';
import JobsearchJobagentBanner from './JobsearchJobagentBanner.vue';
import { getNumberFormatter } from 'JIX/utils.js';
import { __, __nx } from 'JIX/gettext.js';
import SvgIcon from 'JIX/components/SvgIcon.vue';
import "icons/button-list-view.svg";
import "icons/map-address-marker-itjdk.svg";
import "icons/map-address-marker-stedk.svg";
import "icons/map-address-marker-jobdk.svg";
import "icons/clear.svg";

const store = useStore();
const numberFormatter = getNumberFormatter();

async function showListMode(){
    return store.dispatch('performSearch', { newViewMode: 'list' });
}
</script>

<template>
    <section class="container d-flex justify-content-center">
        <div class="col-lg-9 mb-5">
            <button
                type="button"
                :aria-label="__('Listevisning')"
                class="btn btn-sm btn-tertiary gap-2 mb-1"
                @click="showListMode()"
            >
                <SvgIcon name="button-list-view" size="xs" />
                {{ __("Listevisning") }}
            </button>
            <div class="jobsearch-map-container" v-if="store.state.searchResponse.geojson">
                <div class="p-3 d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <h3 class="mb-0" ref="header">
                        {{ __nx('{n} jobannonce', '{n} jobannoncer', store.state.searchResponse.hitcount, { n: numberFormatter.format(store.state.searchResponse.hitcount) }) }}
                    </h3>
                    <div class="d-flex flex-wrap gap-3">
                        <span class="jobsearch-marker-container" v-for="(marker, index) in store.state.mapMarkers" :key="index">
                            <SvgIcon v-if="marker.icon" :name="marker.icon" size="xs" />
                            <span v-else class="jobsearch-marker" :class="'jobsearch-marker-'+marker.typeid" />
                            {{ marker.desc }}
                        </span>
                    </div>
                </div>
                <ClusteredJobsMap
                    :geojson="store.state.searchResponse.geojson"
                    class="jobsearch-map"
                />
            </div>
            <JobsearchJobagentBanner />
            <div class="jobsearch_map_help mb-4 mt-4 container p-0">
                <div class="p-4">
                    <h3>{{ __('Hjælp til søgning på kort') }}</h3>

                    <p>{{ __('Der er tre forskellige typer markeringer på kortet:') }}</p>
                </div>
                <div class="row pb-4" style="margin: auto">
                    <div class="col-lg-4 col-12 order-lg-1 px-4 pb-3">
                        <SvgIcon v-if="store.state.addressMarkerIcon" :name="store.state.addressMarkerIcon" size="md" />
                    </div>
                    <div class="col-lg-4 col-12 order-lg-4 px-4 pb-4 pb-lg-0">
                        <div class="mt-auto">
                            <h5>{{ __('Spids markering') }}</h5>
                            <p>
                                {{ __('Markeringen angiver en præcis adresse, hvor der er ét eller flere ledige job.') }}
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-12 order-lg-2 px-4 pb-3">
                        <div class="rounded-circle example-area-marker d-flex align-items-center">
                            <div class="m-auto">
                                9
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-12 order-lg-5 px-4 pb-4 pb-lg-0">
                        <div class="mt-auto">
                            <h5>{{ __('Geografisk markering') }}</h5>
                            <p>
                                {{ __('Markeringen angiver et geografisk område, hvor der er ét eller flere ledige job.') }}
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-12 order-lg-3 px-4 pb-3">
                        <div class="rounded-circle example-cluster-marker d-flex align-items-center">
                            <div class="m-auto">
                                107
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-12 order-lg-6 px-4">
                        <h5>{{ __('Klyngemarkering') }}</h5>
                        <p>
                            {{ __('Markeringen angiver, at der er mange job koncentreret i et specifikt område.') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
